import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

import { NonProtectedRoute, ProtectedRoute } from "./pages";
import { FallbackComp } from "./components/General/errorBoundary";
import { RootState } from "./store";

const App = () => {
  const { isSeconds } = useSelector((store: RootState) => store.generalStore);

  return (
    <BrowserRouter>
      <ErrorBoundary
        FallbackComponent={FallbackComp}
        onReset={() => window.location.reload()}
      >
        <Routes>
          {/* Non-protected routes */}
          <Route path="/*" element={<NonProtectedRoute />} />

          {/* Protect the dashboard */}
          <Route path="dashboard/*" element={<ProtectedRoute />} />
        </Routes>

        <ToastContainer
          position="bottom-right"
          theme="light"
          autoClose={isSeconds}
          toastStyle={{
            marginLeft: "20px",
            borderRadius: "8px",
            bottom: "6px",
            // marginBottom: "2rem",
          }}
        />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
